import { sel } from "../selectors";
import { DEFAULT_STAGE_VIEWPORT, Scene } from "./types";

// Lesson: Reports from audio → Regenerate. Fixture `regenerateTheNarrative`:
// the Valley Mart interview with the speakers already named but a draft that
// still says "Speaker 2". Confirm POSTs /api/regenerate-narrative (case goes
// to processing); `completeRegeneration` writes the new draft.
const CASE_ID = "c0000000-0000-4000-8000-000000000301";

const scene: Scene = {
  id: "regenerate-the-narrative",
  title: "Regenerate",
  startRoute: `/cases/${CASE_ID}`,
  fixture: "regenerateTheNarrative",
  viewport: DEFAULT_STAGE_VIEWPORT,
  steps: [
    {
      id: "intro",
      narration:
        "Say you've fixed the transcript and named the speakers. The narrative still calls the witness Speaker 2, because it was written before. Regenerate rewrites the whole draft from the current transcript.",
      actions: [
        // "The narrative still calls the witness Speaker 2" 3.1 s to 7.5 s.
        { type: "waitFor", target: sel("editorNarrative") },
        { type: "wait", ms: 3200 },
        { type: "spotlight", target: sel("editorNarrative") },
        { type: "wait", ms: 4300 },
        { type: "spotlight", target: null },
        { type: "wait", ms: 500 },
      ],
    },
    {
      id: "menu",
      narration: "Click the Narrative tab to open its dropdown, then choose Regenerate Narrative.",
      actions: [
        // "then choose" 2.7 s, "Regenerate Narrative" ~3.5 s.
        { type: "moveTo", target: sel("editorTabNarrative") },
        { type: "wait", ms: 300 },
        { type: "click", target: sel("editorTabNarrative") },
        { type: "waitFor", target: sel("regenerateNarrative") },
        { type: "wait", ms: 600 },
        { type: "moveTo", target: sel("regenerateNarrative") },
        { type: "wait", ms: 300 },
        { type: "click", target: sel("regenerateNarrative") },
        { type: "wait", ms: 800 },
      ],
    },
    {
      id: "confirm",
      narration:
        "A dialog warns you that regeneration replaces the entire narrative and discards any manual edits. If something is worth keeping, copy it out first. Then click Confirm.",
      actions: [
        // Warning read 0 s to 6.2 s; "Then click Confirm" starts at ~9.6 s.
        { type: "waitFor", target: sel("regenerateConfirm") },
        { type: "spotlight", target: sel("regenerateDialog") + " .modal-box" },
        { type: "wait", ms: 6000 },
        { type: "spotlight", target: null },
        { type: "moveTo", target: sel("regenerateConfirm") },
        { type: "wait", ms: 2400 },
        { type: "click", target: sel("regenerateConfirm") },
      ],
    },
    {
      id: "processing",
      narration:
        "The case switches to a processing screen while the new draft is written. It usually takes a minute or two, and you can work on other cases in the meantime.",
      actions: [
        { type: "waitFor", target: sel("editorProcessing"), timeoutMs: 15000 },
        { type: "wait", ms: 4500 },
        { type: "fixture", name: "completeRegeneration" },
        { type: "wait", ms: 3000 },
      ],
    },
    {
      id: "result",
      narration:
        "And here's the new draft. The witness is now Daniel Reyes, and the old score and suggestions are replaced with fresh ones.",
      actions: [
        // "The witness is now Daniel Reyes" 1.7 s; score and suggestions 4.0 s.
        { type: "waitFor", target: sel("reportScore"), timeoutMs: 15000 },
        { type: "wait", ms: 1000 },
        { type: "spotlight", target: sel("editorNarrative") },
        { type: "wait", ms: 2300 },
        { type: "spotlight", target: sel("reportScore") },
        { type: "wait", ms: 3000 },
        { type: "spotlight", target: null },
      ],
    },
    {
      id: "settings",
      narration:
        "Regeneration uses your current Report Preferences, so change those first if you want a different style. The template and detail level were fixed when you uploaded. To change them, start a new case from Previous Uploads.",
      actions: [
        // Preferences page while "Report Preferences" is said (0 s).
        { type: "click", target: sel("preferencesButton") },
        { type: "waitFor", target: sel("preferencesForm"), timeoutMs: 15000 },
        { type: "wait", ms: 9000 },
      ],
    },
  ],
};

export default scene;
